module.exports = __webpack_public_path__ + "img/Nofoto.06b10f59.png";